import { getLineStyleForDefaultThresholdLine } from '../../features/threshold/getters';
import { DataRow, EffectiveDefinition } from '../../models';
import { noComparisonRowSubtitle } from './noComparisonSubtitle';
import { historicalComparisonRowSubtitle } from './historicalComparisonSubtitle';
import { targetRowSubtitle } from './targetSubtitle';
import { getDefaultLineForThreshold } from '../../features/threshold/getters';
import { DeltaLabelStyle } from '../../features/threshold/models';

export const createSubtitle = (currentPoint: DataRow, definition: EffectiveDefinition): string | undefined => {
  const line = getDefaultLineForThreshold(definition.features.threshold);
  if (!line) {
    return noComparisonRowSubtitle()();
  }

  const style = getLineStyleForDefaultThresholdLine(definition);
  switch (style?.deltaLabel) {
    case DeltaLabelStyle.HISTORICAL_DELTA:
      return historicalComparisonRowSubtitle(definition)(currentPoint);
    case DeltaLabelStyle.TARGET_VALUE:
      return targetRowSubtitle(definition)(currentPoint);
    default:
      return undefined;
  }
};
